import { FC } from 'react';
import { AddonCategory, ShopContent } from '../../../types/cms_shared_types';
import { AddonCategoryItem } from './AddonCategoryItem';
import { AddonCategoryPickerMobile } from './AddonCategoryPickerMobile';
import { TooltipHelper } from '../TooltipHelper';

interface AddonCategoryPickerProps {
  addonCategories: AddonCategory[];
  cmsShopContent: ShopContent;
  selectedAddonCategoryKey: string | undefined;
  setSelectedAddonCategoryKey: (value: string) => void;
}

export const AddonCategoryPicker: FC<AddonCategoryPickerProps> = ({
  addonCategories,
  cmsShopContent,
  selectedAddonCategoryKey,
  setSelectedAddonCategoryKey,
}) => {
  const switchAddonCategory = (newSelectedAddonCategoryKey: string) => {
    setSelectedAddonCategoryKey(newSelectedAddonCategoryKey);
  };

  return (
    <div className="flex flex-row mb-4 sm:flex-col sm:mb-0 sm:mx-0">
      <div className="flex my-auto sm:flex-row sm:items-center">
        <div className="mr-2 text-base font-extrabold text-text-gray sm:text-text-dark">
          {cmsShopContent.addonsStep.categoryHeader}
        </div>
        {cmsShopContent.addonsStep.addonCategoryTooltip && (
          <TooltipHelper text={cmsShopContent.addonsStep.addonCategoryTooltip} />
        )}
      </div>

      <div className="block ml-auto sm:hidden">
        <AddonCategoryPickerMobile
          addonCategories={addonCategories}
          selectedAddonCategoryKey={selectedAddonCategoryKey}
          cmsShopContent={cmsShopContent}
          switchAddonCategory={switchAddonCategory}
        />
      </div>

      <div className="flex-col hidden sm:flex">
        {addonCategories?.map((addonCategory, index) => {
          return (
            <AddonCategoryItem
              key={index}
              name={addonCategory.name}
              isSelected={selectedAddonCategoryKey === addonCategory.key}
              onClick={() => switchAddonCategory(addonCategory.key)}
            />
          );
        })}
      </div>
    </div>
  );
};
